import React from "react";

const VeterinarianManager = ({
  filteredHorses = [],
  filteredTrainings = [],
}) => {
  const GLOBAL_STYLE = {
    whiteSpace: "normal",
    wordWrap: "break-word",
  };

  const getVeterinarTypeName = (index) => {
    let name = window.VeterinarPage.VeterinarType[0]["Name"];
    for (let i = 0; i < window.VeterinarPage.VeterinarType.length; i++) {
      if (window.VeterinarPage.VeterinarType[i]["value"] == index) {
        name = window.VeterinarPage.VeterinarType[i]["Name"];
        break;
      }
    }
    return name;
  };

  const HEADERS = [
    {
      displayName: window.lang.name,
      name: "Name",
      style: { ...GLOBAL_STYLE, width: 120 },
      onClick: (row) => {
        if (!row.HorseId) return;
        window.Managers.self.editHorseById(row.HorseId);
        window.Managers.extention.showVeterinarian(row.HorseId);
      },
    },
    {
      displayName: window.lang.healthStatus,
      name: "HealthStatus",
      style: { ...GLOBAL_STYLE, width: 120 },
    },
    {
      displayName: window.lang.generalTaskPanels,
      name: "GeneralTaskPanels",
      style: { ...GLOBAL_STYLE, width: 120 },
    },
    {
      displayName: window.lang.date,
      name: "Date",
      style: { ...GLOBAL_STYLE, width: 120 },
    },
    {
      displayName: window.lang.type,
      name: "VetType",
      style: { ...GLOBAL_STYLE, width: 120 },
    },
    {
      displayName: window.lang.remark,
      name: "Remark",
      style: { ...GLOBAL_STYLE },
    },
  ];

  const parseData = () => {
    const data = [];
    filteredTrainings.forEach((training) => {
      const horse = filteredHorses.find((h) => h.id === training.horseid);
      const healthStatus =
        window.DataStorage.getHealthStatuses().filter(
          (status) => status.id == horse?.HealthStatusId
        )[0]?.name || "";
      data.push({
        HorseId: horse?.id,
        Name: horse?.name || "Unknown",
        HealthStatus: healthStatus,
        // If you have a value for GeneralTaskPanels, add it here.
        Date: training.starttime,
        VetType: getVeterinarTypeName(training.VeterinarianType),
        Remark: training.remark,
      });
    });
    return data;
  };

  const data = parseData();

  return (
    <div
      id="vetenerianDataDiv"
      style={{
        overflow: "scroll",
        maxHeight: "calc(100vh - 120px)",
      }}
    >
      <table
        className="farrierTable"
        style={{
          marginTop: "25px",
          tableLayout: "fixed",
          width: "100%",
        }}
      >
        <thead>
          <tr className="feedHeader">
            {HEADERS.map((header, header_index) => (
              <th
                key={header_index}
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  position: "relative",
                  ...header.style,
                }}
              >
                <span style={{ marginLeft: "5px" }}>{header.displayName}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, row_index) => (
            <tr key={row_index}>
              {HEADERS.map((header, header_index) => (
                <td
                  key={header_index}
                  className="centered"
                  style={header.style}
                  onClick={() => header.onClick && header.onClick(row)}
                >
                  <span>{row[header.name]}</span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VeterinarianManager;
